import { render, staticRenderFns } from "./role-multi-checkbox.vue?vue&type=template&id=f6b7032c&"
import script from "./role-multi-checkbox.vue?vue&type=script&lang=js&"
export * from "./role-multi-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports